(function() {
    'use strict';

    angular
        .module('app')
        .filter('uploadImageUrl', uploadImageUrl);

    function uploadImageUrl() {
        return function (input) {
            if (!input) {
                return ''
            }
            const uploadFolder = 'imagens_' + hash_upload + '/'
            return url_upload + uploadFolder + input
        };
    }

})();
